import { Component, Input, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import {
  NgxGalleryAnimation,
  NgxGalleryImage,
  NgxGalleryLayout,
  NgxGalleryOptions,
} from "ngx-gallery";
import { EssentialService } from "../../services/essential.service";
import { MediaManagerService } from "../../services/media-manager.service";
declare const $: any;

@Component({
  selector: "app-gallery",
  templateUrl: "./gallery.component.html",
  styleUrls: ["./gallery.component.css"],
})
export class GalleryComponent implements OnInit {
  @Input() public settings: any;
  @Input() public data: any;
  public media: any = {};
  public parentId: number = 0;
  public searchText: string = "";

  public galleryOptions: NgxGalleryOptions[];
  public galleryImages: NgxGalleryImage[];
  public album: Array<any> = [];
  public fullWidth = false;
  public folders: any[] = [];
  public root = false;
  public orgFolders: any[] = [];
  public currentPath: any;
  public parentFolderPath: any;
  public isLoading: boolean = false;
  public apiUrl = window["config"].apiUrl + "/";
  public site: any;
  currentFolderName: string = "";
  constructor(
    private essentialsService: EssentialService,
    private sinitizer: DomSanitizer,
    private mediaManagerService: MediaManagerService
  ) {
    this.getFancybox();
  }

  public ngOnInit() {
    if (this.settings.folderId) {
      this.getFoldersMedia(this.settings.folderId);
    }
    this.mediaManagerService.changeParentId.subscribe((value) => {
      this.parentId = value;
    });
    this.site = this.data.moduleService.site;

    // if (this.settings.imageAnimation) {
    //   if (this.settings.imageAnimation === "NgxGalleryAnimation.Fade") {
    //     this.settings.imageAnimation = NgxGalleryAnimation.Fade;
    //   }
    //   if (this.settings.imageAnimation === "NgxGalleryAnimation.Slide") {
    //     this.settings.imageAnimation = NgxGalleryAnimation.Slide;
    //   }
    //   if (this.settings.imageAnimation === "NgxGalleryAnimation.Rotate") {
    //     this.settings.imageAnimation = NgxGalleryAnimation.Rotate;
    //   }
    //   if (this.settings.imageAnimation === "NgxGalleryAnimation.Zoom") {
    //     this.settings.imageAnimation = NgxGalleryAnimation.Zoom;
    //   }
    // }
    // this.galleryOptions = [
    //   {
    //     image: this.settings.showImage === "false" ? false : true,
    //     thumbnails: this.settings.showThumbnails === "false" ? false : true,
    //     // imageDescription:this.settings.showTitle ==="false"?false:true,
    //     "imageDescription": true ,
    //     width: this.settings.width ? this.settings.width + "px" : "100%",
    //     imageArrowsAutoHide:
    //       this.settings.imageArrowsAutoHide === "true" ? true : false,
    //     thumbnailsArrowsAutoHide:
    //       this.settings.imageArrowsAutoHide === "true" ? true : false,
    //     height: this.settings.height ? this.settings.height + "px" : "400px",
    //     arrowPrevIcon: this.settings.arrowPrevIcon
    //       ? this.settings.arrowPrevIcon
    //       : "fas fa-arrow-left",
    //     arrowNextIcon: this.settings.arrowNextIcon
    //       ? this.settings.arrowNextIcon
    //       : "fas fa-arrow-right",
    //     thumbnailsColumns: this.settings.thumbnailsColumns
    //       ? this.settings.thumbnailsColumns
    //       : 4,
    //     imageAnimation: this.settings.imageAnimation,
    //     layout:
    //       this.settings.thumbnailsPosition &&
    //       this.settings.thumbnailsPosition === "NgxGalleryLayout.ThumbnailsTop"
    //         ? NgxGalleryLayout.ThumbnailsTop
    //         : NgxGalleryLayout.ThumbnailsBottom,
    //     imageAutoPlay:
    //       this.settings.imageAutoPlay && this.settings.imageAutoPlay === "true"
    //         ? true
    //         : false,
    //     imageAutoPlayInterval: this.settings.imageAutoPlayInterval
    //       ? this.settings.imageAutoPlayInterval
    //       : 2000,
    //     imageAutoPlayPauseOnHover:
    //       this.settings.imageAutoPlayPauseOnHover &&
    //       this.settings.imageAutoPlayPauseOnHover === "true"
    //         ? true
    //         : false,
    //   },
    // ];

    // if (this.settings.folderPath) {
    //   this.getMedia(this.settings.folderPath, false);
    // }
  }

  public getFoldersMedia(id) {
    this.isLoading = true;
    this.mediaManagerService.getFoldersMedia(id).subscribe((res) => {
      this.media = res;
      this.isLoading = false;
    }, (err) => {
      this.isLoading = false;
    })
  }

  public getSubItems(id, folder?) {
    if (id != this.mediaManagerService.parentId) {
      this.mediaManagerService.parentId = id;
      this.mediaManagerService.isParentIdChanged();
      this.getFoldersMedia(id);
      if (this.parentId && this.parentId != this.settings.folderId && folder) {
        this.currentFolderName = folder.name
      } else {
        this.currentFolderName = "";
      }
    }
  }

  
  public getDescription(media) {
    if (media.title) {
      return media.title + (media.description ? ' <br/> ' + media.description : '');
    } else {
      return media.filename;
    }
  }
  
  // public getImages(item) {
  //   return this.settings.config + item.publicUrl;
  // }

  back() {
    window.history.back();
 }

  getMedia(path, isAlbum?) {
    this.isLoading = true;
    this.currentPath = path;
    this.galleryImages = [];
    this.media = [];
    this.folders = [];
    this.album = [];

    this.essentialsService.getMediaData(path).subscribe((res: any) => {
      this.parentFolderPath = res.parentFolderPath || this.parentFolderPath;

      if (res.folders.length > 0) {
        if (!isAlbum) {
          this.orgFolders = res.folders;
        }
        this.folders = res.folders;
      }
      if (res.files.length > 0) {
        this.media = res.files;
        this.configMedia();
      }

      this.isLoading = false;
    });
  }

  configMedia() {
    for (const media of this.media) {
      if (media.publicUrl.indexOf("\\") !== -1) {
        media.publicUrl = media.publicUrl.replaceAll("\\", "/");
      }
      const src = this.settings.config + media.publicUrl;
      const caption = this.settings.showTitle
        ? media.fileName.split(".").slice(0, -1).join(".")
        : "";
      const album = {
        src,
        caption,
        thumb: src,
        contentType: media.contentType,
      };
      this.album.push(album);

      this.galleryImages.push({
        small: this.settings.config + media.publicUrl,
        medium: this.settings.config + media.publicUrl,
        big: this.settings.config + media.publicUrl,
      });
    }
  }
  public getImage(img?) {
    return this.sinitizer.bypassSecurityTrustUrl(img);
  }

  getFancybox() {
    const oldLinks = document.getElementsByTagName("link");
    const oldJs = document.getElementsByTagName("script");
    for (let index = 0; index < oldLinks.length; index++) {
      const element = oldLinks[index];
      const getName = element.getAttribute("name");
      if (getName && getName.indexOf("facnyCSS") !== -1) {
        document.head.removeChild(element);
        index = index - 1;
      }
    }
    for (let index = 0; index < oldJs.length; index++) {
      const element = oldJs[index];
      const getName = element.getAttribute("name");
      if (getName && getName.indexOf("facnyJS") !== -1) {
        document.body.removeChild(element);
        index = index - 1;
      }
    }

    var css =
      "https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.5.7/jquery.fancybox.css";
    var js =
      "https://cdnjs.cloudflare.com/ajax/libs/fancybox/3.5.7/jquery.fancybox.min.js";

    const facnyCSS = document.createElement("link");
    facnyCSS.setAttribute("rel", "stylesheet");
    facnyCSS.setAttribute("type", "text/css");
    facnyCSS.setAttribute("name", "facnyCSS");
    facnyCSS.setAttribute("href", css);
    document.head.appendChild(facnyCSS);

    const facnyJS = document.createElement("script");
    facnyJS.setAttribute("name", "facnyJS");
    facnyJS.setAttribute("src", js);
    document.body.appendChild(facnyJS);
  }
}
